/* eslint-disable max-len */
import { SvgIcon } from '@mui/material';
import { CustomSvgIcon } from '@tassat/ui-definitions';
import * as React from 'react';

export default function SortIcon(props: CustomSvgIcon) {
    const {
        id,
        className,
        iconColor,
        onClick
    } = props;

    return (
        <SvgIcon
            className={className || ''}
            id={id || ''}
            onClick={onClick}
            viewBox='0 0 34 26'
        >
            <svg
                height='26px'
                version='1.1'
                viewBox='0 0 34 26'
                width='34px'
                xmlns='http://www.w3.org/2000/svg'
                xmlnsXlink='http://www.w3.org/1999/xlink'
            >
                <title>Sort</title>
                <g
                    fill={iconColor || 'none'}
                    fillRule='evenodd'
                    id='The-Network-'
                    stroke='none'
                    strokeWidth='1'
                >
                    <g
                        id='Admin-Dash'
                        transform='translate(-309.000000, -127.000000)'
                    >
                        <g
                            id='Sort'
                            transform='translate(310.000000, 128.000000)'
                        >
                            <path
                                d='M12.7279662,8.18181818 C12.9182293,8.18181818 13.0744679,8.32015108 13.0959954,8.49809508 L13.0980788,8.5404 L13.0980788,16.62817 L14.8222683,14.9614674 L14.8549044,14.9332641 C15.0000345,14.8224641 15.2118233,14.8311936 15.3458412,14.9614674 C15.4798609,15.0903987 15.4895811,15.2938693 15.3770889,15.4342153 L15.3458412,15.4677907 L12.7273458,18 L10.1088503,15.4677907 L10.079686,15.43623 C9.97413736,15.307971 9.9734423,15.1246462 10.0776026,14.9950446 L10.1088503,14.9614691 L10.1407931,14.9332659 C10.2741177,14.8311953 10.4629943,14.8305231 10.5970122,14.9312511 L10.6324268,14.9614691 L12.3573095,16.6295126 L12.3580046,8.54036733 C12.3580046,8.35637387 12.5010512,8.20528367 12.6850587,8.18446557 L12.7279662,8.18181818 Z M19.2725534,6 L21.8911456,8.53223504 L21.920311,8.56379601 C22.0258636,8.69205638 22.0265587,8.87538298 21.9223945,9.00498596 L21.8911456,9.03856172 L21.8592017,9.06676528 C21.7258721,9.16883687 21.5369886,9.16950904 21.4029657,9.06878007 L21.3675499,9.03856172 L19.6412167,7.36916041 L19.6412167,15.4595912 C19.6412167,15.6435865 19.4981648,15.7946783 19.3141504,15.8154966 L19.2710957,15.8181818 C19.0808255,15.8181818 18.9245811,15.6798475 18.9030528,15.5019017 L18.9009693,15.4595964 L18.9002742,7.37174421 L17.1774076,9.03846373 L17.1454636,9.06666729 C16.9996349,9.17746848 16.7878382,9.16873888 16.6538154,9.03846373 C16.5204858,8.90953119 16.5100701,8.70605845 16.6232598,8.56571109 L16.6538154,8.53213534 L19.2725534,6 Z'
                                fill='#000000'
                                id='Fill-1'
                            />
                        </g>
                    </g>
                </g>
            </svg>
        </SvgIcon>
    );
}